import { GestureHandling } from 'savills-ui-kit';

export const DEFAULT_MAP_SETTINGS = {
  zoom: 16,
  latLng: { lat: 51.5, lng: -0.1 },
  gestureHandling: GestureHandling.Cooperative,
};

export const MAP_PIN_URL = 'https://assets.savills.com/static/map/pin.svg';
